import Vue from 'vue';
import Vuex from 'vuex';

import modules from './modules';

Vue.use(Vuex);

// TODO
// Change to a namespaced !
const createStore = () => {
	Vue.config.devtools = true;
	return new Vuex.Store({
		state: {},
		mutations: {},
		actions: {},
		modules,
	});
};

const store = createStore();

const addWatchers = (store) => {
	Object.values(modules).forEach((module) => {
		const { watchers } = module;
		if (watchers) {
			watchers.forEach((watcher) => {
				const { fnOrExpr, callback } = watcher;
				const options = watcher.options || {};
				store.watch(fnOrExpr, (...args) => callback(store, ...args), options);
			});
		}
	});
};

addWatchers(store);

export default store;
